<!-- 课程实操 -->
<template>
    <div>
      <el-row class="course_practicalTraining">
        <ul>
          <template v-for="(item, index) in dataList">
            <li :key="index">
              <span class="num_practicalTraining">{{index + 1}}</span>
              <el-row>
                <p class="title_practicalTraining limit_line_one">实训项目名称：{{item.handsOnName}}</p>
                <p class="number_practicalTraining"  style="color: #2789E2;">
                  <span style="float: right;">任务总数量：{{item.handsOnTaskNum}}</span>
                </p>
              </el-row>
              <el-row class="m20">
                <p class="grade_practicalTraining">{{item.studentScore || 0}}<span>分</span></p>
              </el-row>
              <el-row class="mb20">
                <el-col :span="16" class="font12 mt20">
                  <el-col :span="7" class="tc">完成进度：</el-col>
                  <el-col :span="17" class="tc">
                    <el-progress :text-inside="true" :stroke-width="18" :percentage="item.schedule || 0"></el-progress>
                  </el-col>
                </el-col>
                <el-col :span="4" class="tc" v-if='userType == 1'>
                  <i class="el-icon-video-play c_p font25" style="color: #2789E2;" @click="TrainingIndex(item,index)"></i>
                  <br>
                  <el-link style="margin-top: 5px;font-size: 14px;" :underline="false" @click="TrainingIndex(item,index)">开始实操</el-link>
                </el-col>
                <el-col :span="4" class="tc" v-if='userType == 1'>
                  <i class="el-icon-tickets c_p font25" style="color: #FF6554;" @click="achievement(item,index)"></i>
                  <br>
                  <el-link style="margin-top: 5px;font-size: 14px;" :underline="false" @click="achievement(item,index)">成绩详情</el-link>
                </el-col>
                <el-col :span="4" class="tc" v-if='userType == 2'>
                  &nbsp;
                </el-col>
                <el-col :span="4" class="tc" v-if='userType == 2'>
                  <i class="el-icon-tickets c_p font25" style="color: #FF6554;" @click="detailsInfo(item,index)"></i>
                  <br>
                  <el-link style="margin-top: 5px;font-size: 14px;" :underline="false" @click="detailsInfo(item,index)">查看详情</el-link>
                </el-col>
              </el-row>
            </li>
          </template>
        </ul>
      </el-row>
      <div v-if="dataList.length > 0"  class="block" style="text-align: right;bottom: 0;width: 96%;margin">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="page"
          :page-sizes="[8, 20, 50, 100]"
          :page-size="limit"
          background
          :hide-on-single-page="true"
          layout="sizes, prev, pager, next,jumper"
          :total="total">
        </el-pagination>
      </div>
      <el-empty v-if="dataList.length <= 0" description=""></el-empty>
    </div>
</template>
<script>

export default {
  name: 'PracticalTraining',
  props: {
    courseId: { //课程ID
      type: String,
      required:true
    },
    courseInfoName: { //课程名称
      type: String,
    },
    courseType:{ //课程类型 1：开课 2：授权课
      type: String,
      required:true
    }
  },
  data() {
    return {
      dataList: [],
      total: 0,
      limit:8,
      page:1,
      userType:this.$Base64.decode(this.$ls.get(this.$getKeyInfo("userType"))), //获取用户类型 1：学生
    }
  },
  created() {
    this.getInfo();
  },
  mounted() {
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.limit = val;
      this.getInfo();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getInfo();
    },
    getInfo(){ //获取数据
      let url = "",param ={};
      if(this.courseType == 1){
        url = "/api/teacherOpenCourseHandsOn/getCourseCentreHandsListByOpenCourseIdAndStudent.do";
        param = {
          limit:this.limit,
          page:this.page,
          teacherOpenCourseId:this.courseId
        }
      }else if(this.courseType == 2){
        url = "/api/handsOn/getCourseCentreHandsListCenterByOpenCourseId.do";
        param = {
          courseInfoId:this.courseId
        }
      }
      this.$get(url,param).then((ret) =>{
        if(ret.code == 0){
          this.total = Number(ret.count);
          this.dataList = ret.data;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    TrainingIndex(item,index){ //开始答题
      this.$router.push({name:'LookTrainingIndex',query:{courseType:this.courseType,examType:1,handsOnId:item.handsOnId,courseId:this.courseId,courseInfoName:this.courseInfoName,chapterId:item.chapterId}});
    },
    achievement(item,index){ //查看成绩
      this.$router.push({name:'LookTrainingIndex',query:{courseType:this.courseType,examType:2,handsOnId:item.handsOnId,courseId:this.courseId,courseInfoName:this.courseInfoName,chapterId:item.chapterId}});
    },
    detailsInfo(item,index){ //查看成绩
      this.$router.push({name:'LookTrainingIndex',query:{courseType:this.courseType,examType:3,handsOnId:item.handsOnId,courseId:this.courseId,courseInfoName:this.courseInfoName,chapterId:item.chapterId}});
    }
  }
};
</script>
<style  lang="less">
  .course_practicalTraining{
    ul{
      list-style-type:none;
      margin: 0;
      padding: 0;
    }
    li{
      float: left;
      width: calc(33.2% - 66px);
      margin: 0 20px 20px 0;
      min-height: 200px;
      border: 1px solid #E1E1E1;
      background-image: url("../../../../images/course/num_bg@2x.png");
      background-size: 50px;
      background-repeat:no-repeat;
      position: relative;
      padding: 20px 20px 0;
      font-size: 14px;
      .num_practicalTraining{
        position: absolute;top: 10px;left: 10px;color: #2789E2;
      }
    }
    .title_practicalTraining{
      margin: 0;
      margin-left: 15px;float: left;
      width: calc(100% - 180px);
    }
    .number_practicalTraining{
      margin: 0;
      float: right;
      width: 165px;
    }
    .grade_practicalTraining{
      display: flex;
      justify-content:center;
      align-items:center;
      width: 80px;height: 80px;margin: 0 auto;
      font-size: 22px;
      color: #F83131;
      background-color: #FFF6F6;
      border-radius: 50%;
      span{
        font-size: 14px;
        margin-left: 2px;
      }
    }
    .practicalTraining_img{
      width: 30px;
    }

    @media screen and (max-width:1536px){
      li{
        width: calc(33% - 66px);
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/lookCourse/components/PracticalTraining/PracticalTraining.vue